import { useApplicationModals } from "app/common/hooks";
import { Button } from "app/components/atoms/button";
import { InputLabel } from "app/components/atoms/form";
import { Input } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";
import { Select } from "app/components/atoms/select";
import api from "app/integration/api";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbItems = [
  { label: "Gudang", href: "#" },
  { label: "Transfer Gudang", href: "/warehouse-transfer" },
  { label: "Buat Transfer", href: "#" },
];

function WarehouseTransferCreate() {
  const navigate = useNavigate();
  const { openModal, setPayloads } = useApplicationModals();

  const [warehouses, setWarehouses] = useState([]);
  const [sourceWarehouseId, setSourceWarehouseId] = useState("null");
  const [destWarehouseId, setDestWarehouseId] = useState("null");
  const [notes, setNotes] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showError = (title, err) => {
    setPayloads("errorMessage.view", {
      title,
      message: err?.response?.data?.message ?? "Gagal membuat transfer",
    });
    openModal("errorMessage.view");
  };

  useEffect(() => {
    const loadWarehouses = async () => {
      try {
        const response = await api.warehouse.index({ limit: 1000 });
        setWarehouses(response?.data ?? []);
      } catch (err) {
        setWarehouses([]);
        showError("Transfer Gudang", err);
      }
    };
    loadWarehouses();
  }, []);

  const warehouseOptions = [
    { value: "null", label: "Gudang Utama" },
    ...warehouses.map((warehouse) => ({
      value: String(warehouse.id),
      label: warehouse.name ?? "Gudang #" + warehouse.id,
    })),
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (sourceWarehouseId === destWarehouseId) {
      setPayloads("errorMessage.view", {
        title: "Transfer Gudang",
        message: "Gudang asal dan gudang tujuan tidak boleh sama.",
      });
      openModal("errorMessage.view");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.warehouseTransfer.create({
        source_warehouse_id:
          sourceWarehouseId === "null" ? null : Number(sourceWarehouseId),
        dest_warehouse_id:
          destWarehouseId === "null" ? null : Number(destWarehouseId),
        notes,
      });
      navigate("/warehouse-transfer/" + response?.data?.id);
    } catch (err) {
      showError("Transfer Gudang", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MainLayout
      activeSidebarNavigation="warehouse"
      activeSidebarChild="warehouse-transfer"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Buat Transfer Gudang"
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{ "errorMessage.view": () => {} }}
      />
      {/* min-height reserves room for the open warehouse dropdown so its absolute
          panel doesn't overflow the short #main-content scroll box (which would
          otherwise trigger a stray right-side scrollbar on this short page). */}
      <form className="px-2 min-h-[24rem]" onSubmit={handleSubmit}>
        <FormHeader>
          {/* Descending z-index so each open dropdown floats above the fields below it */}
          <div className="relative z-20">
            <InputLabel required>Gudang Asal</InputLabel>
            <Select testId="warehouse-transfer-create-source-warehouse-id-select"
              placeholder="Pilih Gudang Asal"
              name="source_warehouse_id"
              options={warehouseOptions}
              value={sourceWarehouseId}
              onChange={(e) => setSourceWarehouseId(e.target.value)}
            />
          </div>
          <div className="relative z-10">
            <InputLabel required>Gudang Tujuan</InputLabel>
            <Select testId="warehouse-transfer-create-dest-warehouse-id-select"
              placeholder="Pilih Gudang Tujuan"
              name="dest_warehouse_id"
              options={warehouseOptions}
              value={destWarehouseId}
              onChange={(e) => setDestWarehouseId(e.target.value)}
            />
          </div>
          <div className="relative sm:col-span-2 md:col-span-2 lg:col-span-2">
            <InputLabel>Catatan</InputLabel>
            <Input testId="warehouse-transfer-create-notes-input"
              type="text"
              name="notes"
              placeholder="Catatan (opsional)"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
        </FormHeader>
        <div className="flex justify-end mt-4">
          <div className="w-full sm:w-48">
            <Button testId="warehouse-transfer-create-simpan-button" type="submit" loading={isSubmitting}>
              Simpan
            </Button>
          </div>
        </div>
      </form>
    </MainLayout>
  );
}

export default WarehouseTransferCreate;
